define('comments',[
  "globals",
  "backbone",
  "models/comments",
  "collections/comments",
  "views/comments/comments",
  "./content",
  "./nav"
], function (globals, Backbone, CommentModel, CommentList, CommentsView) {

  "use strict";

  if (globals.options.ui.commentsEnabled && globals.options.userLoggedIn) {
    $(function () {
      new CommentsView({
        name: "comments",
        el: "#comments",
        // The comments for the first topic that the user opens (that is, the
        // first page that they load) are bootstrapped onto the page as JSON,
        // so we can prepopulate the collection with them.
        collection: new CommentList(globals.content.get("comments"), {
          model: CommentModel
        })
      });
    });
  }
});

